import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldAlert } from "lucide-react";

export default function ForcePasswordChange() {
  const { setUser, logout } = useAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("New password and confirmation do not match."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      const me = await api.get("/auth/me");
      setUser(me.data);
      toast.success("Password updated — welcome in.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not change password.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4" data-testid="force-password-change">
      <div className="w-full max-w-md bg-card border border-border rounded-lg p-8 shadow-sm">
        <div className="flex items-center gap-2 text-accent"><ShieldAlert className="w-6 h-6" /><span className="font-display text-xl font-bold">Set a new password</span></div>
        <p className="text-sm text-muted-foreground mt-2">For security, you must choose a new password before continuing. Use at least 12 characters with an uppercase letter, a lowercase letter, and a number.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-[0.15em] text-muted-foreground">Current password</Label>
            <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="fpc-current" autoComplete="current-password" required />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-[0.15em] text-muted-foreground">New password</Label>
            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="fpc-new" autoComplete="new-password" required />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-[0.15em] text-muted-foreground">Confirm new password</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="fpc-confirm" autoComplete="new-password" required />
          </div>
          <Button type="submit" disabled={busy || !cur || !next} className="w-full h-11" data-testid="fpc-submit">{busy ? "Saving…" : "Change Password & Continue"}</Button>
        </form>
        <button onClick={logout} className="mt-4 text-xs text-muted-foreground hover:text-foreground underline w-full text-center" data-testid="fpc-logout">Sign out instead</button>
      </div>
    </div>
  );
}
